import React, { useState, useEffect } from 'react'
import Card from 'react-bootstrap/Card'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ReactSwitch from 'react-switch'
import axios from 'axios'
import Swal from 'sweetalert2'
import { apiRequest } from '../../store/allApi'


const Gateway = () => {

//////////URL//////////////
const [isPayOneUpi, SetisPayOneUpi] = useState('')
const [isPayTwoUpi, SetisPayTwoUpi] = useState('')
const [BankName, setBankName] = useState('')
const [acNO, setAcNo] = useState('')
const [holderName, setHolderName] = useState('')
const [IFSC, setIfsc] = useState('')
const [BankName1, setBankName1] = useState('')
const [acNO1, setAcNo1] = useState('')
const [holderName1, setHolderName1] = useState('')
const [IFSC1, setIfsc1] = useState('')
const [UpiGatewayKey, setUpiGatewayKey] = useState('')
const [acRangemin, setAcRangemin] = useState('')
const [acRangemax, setAcRangemax] = useState('')
const [upiRangemin, setUpiRangemin] = useState('')
const [upiRangemax, setUpiRangemax] = useState('')
const [gatewayRangemin, setgatewayRangemin] = useState('')
const [gatewayRangemax, setgatewayRangemax] = useState('')
const [qrRangemin, setqrRangemin] = useState('')
const [qrRangemax, setqrRangemax] = useState('')
const [whatsappRangemin, setWhatsappRangemin] = useState('')
const [whatsappRangemax, setWhatsappRangemax] = useState('')
const [upiIdAccount, setUpiIdAccount] = useState('')
const [upi, setUpiId] = useState('')
  const [checkedMyPayIn, setCheckedMyPayIn] = useState(true)
  const [checkedAcDeposit, setAcDeposit] = useState(true)
  const [manualDeposit, setManualDeposit] = useState(true)
  const [checkedMyPay, setCheckedMyPay] = useState(true)
  const [isUpiGateway, setisUpiGateway] = useState(true)
  const [AccountName, setAccountName] = useState()
  const [settingId, setSettingId] = useState('')
  const [PayNowOne, setPayNowOne] = useState(true)
  const [PayNowTwo, setPayNowTwo] = useState(true)
  const [whatsappDeposit, setWhatsappDeposit] = useState(true)
  const [PayNowThree, setPayNowThree] = useState(true)
  const [payNowFour, setPayNowFour] = useState(true)
  const [isPayNowFive, setPayNowFive] = useState(true)


  // images manual payment
const [payOneImage,setPayOneImage] = useState(null)
const [payTwoImage,setPayTwoImage] = useState(null)
const [payThreeImage,setPayThreeImage] = useState(null)
const [payFourImage,setPayFourImage] = useState(null)
const [payFiveImage,setPayFiveImage] = useState(null)

  // console.log(enable_otp)
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const getData = async() => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
     try {
                      const res = await apiRequest(`gatewaysettings/data`,"GET", null,headers)
                     if (res.data) {
                      //  console.log(res.data)
      setSettingId(res.data._id ? res.data._id : '')
      setAccountName(res.data.AccountName)
      setUpiId(res.data.upi)
      setBankName(res.data.BankName)
      setAcNo(res.data.acNO)
      setHolderName(res.data.holderName)
      setIfsc(res.data.IFSC)
      setBankName1(res.data.BankName1)
      setAcNo1(res.data.acNO1)
      setHolderName1(res.data.holderName1)
      setIfsc1(res.data.IFSC1)
      setUpiGatewayKey(res.data.UpiGatewayKey)
      setAcRangemin(res.data.acRangemin)
      setAcRangemax(res.data.acRangemax)
      setUpiRangemin(res.data.upiRangemin)
      setUpiRangemax(res.data.upiRangemax)
      setgatewayRangemin(res.data.gatewayRangemin)
      setgatewayRangemax(res.data.gatewayRangemax)
      setqrRangemin(res.data.qrRangemin)
      setqrRangemax(res.data.qrRangemax)
      setWhatsappRangemin(res.data.whatsappRangemin)
      setWhatsappRangemax(res.data.whatsappRangemax)
      setUpiIdAccount(res.data.upiIdAccount)
      setCheckedMyPayIn(res.data.isMypayInActive)
      setCheckedMyPay(res.data.isMypayOutActive)
      setisUpiGateway(res.data.isUpiGateway)
      setManualDeposit(res.data.manualDeposit)
      setAcDeposit(res.data.AcDeposit)
      setPayNowOne(res.data.isPayNowOne)
      setPayNowTwo(res.data.isPayNowTwo)
      setWhatsappDeposit(res.data.whatsappDeposit)
      setPayNowThree(res.data.isPayNowThree)
      setPayNowFour(res.data.isPayNowFour)
      setPayNowFive(res.data.isPayNowFive)
      setPayOneImage(res.data.isPayOneImage)
      setPayTwoImage(res.data.isPayTwoImage)
      SetisPayOneUpi(res.data.isPayOneUpi)
      SetisPayTwoUpi(res.data.isPayTwoUpi)
                     }
                        } catch (e) {
                          console.log(e);
                        }
                        finally {
                        }
  }

  useEffect(() => {
getData()
   
  }, [])

  const handleSubmit1 = async (type,e) => {
    // e.preventDefault()
    console.log(type)
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }


    var formdata = new FormData();
      formdata.append("status", PayNowOne);
      formdata.append("image", payTwoImage);
      formdata.append("settingId", settingId);
      
      formdata.append("checkedAcDeposit", checkedAcDeposit);
      formdata.append("isUpiGateway", isUpiGateway);
      formdata.append("upiRangemin", upiRangemin);
      formdata.append("upiRangemax", upiRangemax);
      formdata.append("gatewayRangemin", gatewayRangemin);
      formdata.append("gatewayRangemax", gatewayRangemax);
      formdata.append("qrRangemin", qrRangemin);
      formdata.append("qrRangemax", qrRangemax);
      formdata.append("whatsappRangemin", whatsappRangemin);
      formdata.append("whatsappRangemax", whatsappRangemax);
      // formdata.append("acRangemin", acRangemin);
      // formdata.append("acRangemax", acRangemax);
      // formdata.append("upiIdAccount", upiIdAccount);
      // formdata.append("acNO", acNO);
      // formdata.append("BankName", BankName);
      // formdata.append("holderName", holderName);
      // formdata.append("IFSC", IFSC);
      formdata.append("acNO1", acNO1);
      formdata.append("BankName1", BankName1);
      formdata.append("holderName1", holderName1);
      formdata.append("IFSC1", IFSC1);
      // formdata.append("AccountName", AccountName);
      // formdata.append("UpiGatewayKey", UpiGatewayKey);
      formdata.append("manualDeposit", manualDeposit);
      // formdata.append("checkedMyPay", checkedMyPay);
      formdata.append("PayNowOne", PayNowOne);
      formdata.append("PayNowTwo", PayNowTwo);
      formdata.append("whatsappDeposit", whatsappDeposit);
      formdata.append("settingId", settingId);
      // formdata.append("upi", upi);
      formdata.append("isPayOneUpi", isPayOneUpi);
      formdata.append("isPayTwoUpi", isPayTwoUpi);
      formdata.append("image_type", type);

      try {
                      const res = await apiRequest(`gatewaysettings/save`,"POST", formdata,headers)
                     if (res.data.status === 'success') {
                           alert('Settings submitted successfully')
                     }
                        } catch (e) {
                               alert('Settings Not Submitted')
                        }
                        finally {
                        }
  }
 


 
  const handleChangeGateway = val => {
    setisUpiGateway(val)
  }
 
  const handleAcDeposit = val => {
    setAcDeposit(val)
  }

  const handleChangePayOne = val => {
    setPayNowOne(val)
  }
  const handleChangePayTwo = val => {
    setPayNowTwo(val)
  }
  const handleChangeWhatsapp = val => {
    setWhatsappDeposit(val)
  }

const userData = localStorage.getItem("userData")


  return (
    <>
      <div className='card mt-5'>
        <div className='card-body  table_bg'>
          <h4 className='dashboard_heading my-3'>Payment Gateway Settings</h4>

          {/* <h4 className='my-3 dashboard_small_heading_dark'>Pay In Or Pay Out</h4> */}
           

          {/* <h5 className='dashboard_small_heading_dark my-3'>RazorPay</h5> */}

          <form
            action='GetwaySetting'
            className='form'
            method='patch'
            enctype='multipart/form-date'
          >

           <div className='form-row'>
           <div className='form-group col-md-6'>
                <Card>
                  <Card.Body>
                    <h4 className='dashboard_small_heading_blue'>
                     Qr Code Upload
                    </h4>
                    <Container>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Enable</Col>
                        <Col sm={2}>
                          {' '}
                          <ReactSwitch
                            checked={PayNowTwo}
                            onChange={handleChangePayTwo}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>

<Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>UPI ID</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={isPayTwoUpi}
                            onChange={e => SetisPayTwoUpi(e.target.value)}
                            placeholder='Enter Upi Id'
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Image</Col>
                        <Col sm={1}>
                          <input
                            type='file'
                            accept='image/*'
                            name='rkludoPopular'
                            onChange={e =>
                              setPayTwoImage(e.target.files[0])
                            }
                            style={{ width: '200px' }}
                          />
                        </Col>
                      </Row>

                     
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}></Col>
                        <Col sm={4}>
                        <a href={baseUrl + `/${payTwoImage}`} target='_blank'>
                          <img src={baseUrl + `/${payTwoImage}`} style={{height:"50px", width:"50px"}}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://cdn1.vectorstock.com/i/1000x1000/94/00/selected-stamp-vector-9519400.jpg';
                          }}
                          />
                        </a>
                        </Col>
                        </Row>
                        {
                          userData == "Admin" ?
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Range-Min</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={qrRangemin}
                            onChange={e => setqrRangemin(e.target.value)}
                            placeholder='Enter Range Max'
                          />
                        </Col>
                      </Row> :""
                        }
                          {
                          userData == "Admin" ?
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Range-Max</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={qrRangemax}
                            onChange={e => setqrRangemax(e.target.value)}
                            placeholder='Enter Range Max'
                          />
                        </Col>
                      </Row> :""
                        }
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>
                        <button type='button' className='btn btn-dark' onClick={e => handleSubmit1("PayNowTwo")}>
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>

              <div className='form-group col-md-6'>
                <Card>
                  <Card.Body>
                    <h4 className='dashboard_small_heading_blue'>
                     Upi Id
                    </h4>
                    <Container>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Enable</Col>
                        <Col sm={2}>
                          {' '}
                          <ReactSwitch
                            checked={PayNowOne}
                            onChange={handleChangePayOne}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>
 <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Bank Name</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={BankName1}
                            onChange={e => setBankName1(e.target.value)}
                            placeholder='Enter Bank Name'
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Account No</Col>
                        <Col sm={1}>
                          <input
                            type='number'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={acNO1}
                            onChange={e => setAcNo1(e.target.value)}
                            placeholder='Enter Account No'
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Benificary Name</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={holderName1}
                            onChange={e => setHolderName1(e.target.value)}
                            placeholder='Account Holder Name'
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>IFSC CODE</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={IFSC1}
                            onChange={e => setIfsc1(e.target.value)}
                            placeholder='Enter IFSC CODE'
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>UPI ID</Col>
                        <Col sm={1}>
                          {' '}
                          <input
                            type='text'
                            name='ludokingroomcodeURL'
                            value={isPayOneUpi}
                            onChange={e =>
                              SetisPayOneUpi(e.target.value)
                            }
                            style={{
                              border: '1px solid black',
                              borderRadius: '3px'
                            }}
                            placeholder='Enter UPI'
                          />
                        </Col>
                      </Row>
                      {
                          userData == "Admin" ?
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Range-Min</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={upiRangemin}
                            onChange={e => setUpiRangemin(e.target.value)}
                            placeholder='Enter Range Min'
                          />
                        </Col>
                      </Row> :""}
                      {
                          userData == "Admin" ?
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Range-Max</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={upiRangemax}
                            onChange={e => setUpiRangemax(e.target.value)}
                            placeholder='Enter Range Max'
                          />
                        </Col>
                      </Row> :""}
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>
                        <button type='button' className='btn btn-dark' onClick={e => handleSubmit1("PayNowOne")}>
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>

                <div className='form-group col-md-6'>
                <Card>
                  <Card.Body>
                    <h4 className='dashboard_small_heading_blue'>
                  Whatsapp Deposit
                    </h4>
                    <Container>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Enable</Col>
                        <Col sm={2}>
                          {' '}
                          <ReactSwitch
                            checked={whatsappDeposit}
                            onChange={handleChangeWhatsapp}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>
                     
                       {
                          userData == "Admin" ? 
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Range-Min</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={whatsappRangemin}
                            onChange={e => setWhatsappRangemin(e.target.value)}
                            placeholder='Enter Range Max'
                          />
                        </Col>
                      </Row> :""}
                      {
                          userData == "Admin" ?
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Range-Max</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={whatsappRangemax}
                            onChange={e => setWhatsappRangemax(e.target.value)}
                            placeholder='Enter Range Max'
                          />
                        </Col>
                      </Row> :""}
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>
                        <button type='button' className='btn btn-dark' onClick={e => handleSubmit1("PayNowTwo")}>
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>

         {
          userData == "Admin" ?

           <div className='form-group col-md-6'>
                <Card>
                  <Card.Body>
                    <h4 className='dashboard_small_heading_blue'>
                  UpiGateway
                    </h4>
                    <Container>
                     

                    <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}> UpiGateway Deposit</Col>
                        <Col sm={2}>
                          {' '}
                          <ReactSwitch
                            checked={isUpiGateway}
                            onChange={handleChangeGateway}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>

{
                          userData == "Admin" ?
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Upi Min</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={gatewayRangemin}
                            onChange={e => setgatewayRangemin(e.target.value)}
                            placeholder='Enter Range Min'
                          />
                        </Col>
                      </Row> :""}
                      {
                          userData == "Admin" ?
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Upi Max</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={gatewayRangemax}
                            onChange={e => setgatewayRangemax(e.target.value)}
                            placeholder='Enter Range Max'
                          />
                        </Col>
                      </Row> :""}
                    
                      {/* <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Gateway Key</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={UpiGatewayKey}
                            onChange={e => setUpiGatewayKey(e.target.value)}
                            placeholder='Enter Gateway Key'
                          />
                        </Col>
                      </Row> */}

                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                       <Col sm={6}>
                        <button type='button' className='btn btn-dark' onClick={e => handleSubmit1("PayNowTwo")}>
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div> :""
         }
            </div>

            

            {/* <div className='form-row'>
              <div className='form-group col-md-4'>
                <button type='submit' className='btn btn-dark'>
                  submit
                </button>
              </div>
            </div> */}
          </form>
     
       
        </div>
      </div>
    </>
  )
}

export default Gateway
